import { Select } from 'antd';
import * as React from 'react';

interface CustomSelectFieldProps {
  placeholder: string;
  label: string;
  defaultValue?: any;
  options: React.ReactNode | React.ReactNode[];
  allowClear: boolean;
  onChanged?: (any) => any;
}

const CustomSelectField: React.FC<CustomSelectFieldProps> = ({
  label,
  defaultValue,
  options,
  allowClear = true,
  ...props
}) => (
  <Select labelInValue={false} allowClear={allowClear} {...props}>
    {options}
  </Select>
);

export default CustomSelectField;
